import path from 'path'

import {checkStatus} from '../../__utils/utils'

export const sendHrData = formRequest => {
  const {name, email, phone, source, comment, attachment} = formRequest

  const template = {
    'template_name': 'new_job_application',
    'language': 'ru',
    'body_values': {
      'firstname': name || '',
      'email': email || '',
      'phonenumber': phone || '',
      'comment1': source || '',
      'comment2': `${comment || ``}\n Отправлено со страницы: ${document.location.href}`
    },
    'subject_values': {}
  }

  template['subject_values'].vacancy = document.title.replace('Вакансия: ', '')

  const formData = new FormData()

  formData.append('recipient', 'hr@selectel.ru')
  formData.append('project', 'internal')
  formData.append('template', JSON.stringify(template))
  formData.append(
    'attachment',
    attachment.originFileObj,
    `resume${path.extname(attachment.name)}`
  )

  return fetch('https://api.selectel.ru/proxy/public/notification/notification/email/', {
    method: 'POST',
    body: formData
  })
  .then(checkStatus)
}